import { FC } from 'react';

import HTMLContent from '@telialt/common-html-content/src';
import { selectProductInCart } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { ESHOP_TEST_ID } from '../../test/test-ids';
import { CartLegalTextWrapper } from './CartLegalText.styles';

export const CartLegalText: FC = () => {
    const { cart } = useCartQuery();

    const product = selectProductInCart(cart);
    const legalText = product?.legalText;

    return (
        legalText && (
            <CartLegalTextWrapper data-test={ESHOP_TEST_ID.CART_BOX_LEGAL_TEXT}>
                <HTMLContent content={legalText} />
            </CartLegalTextWrapper>
        )
    );
};
